export const ApplicationsAccessEnum = Object.freeze({
    APP_RESUME: 'APP_RESUME',
    APP_CONCOURS: 'APP_CONCOURS',
    APP_PARCOURIR_NATIONAL: 'APP_PARCOURIR_NATIONAL',
    APP_PARCOURIR: 'APP_PARCOURIR',
    APP_EXPORT: 'APP_EXPORT',
    APP_ADMIN_EXPORT: 'APP_ADMIN_EXPORT',
    APP_COMMERCIALS: 'APP_COMMERCIALS',
    APP_PRO_PERSONAL: 'APP_PRO_PERSONAL',
    APP_PRO_OF_OTHER: 'APP_PRO_OF_OTHER'
});
